import axios from "axios";
import { Controller } from "@hotwired/stimulus";
import InputMask from "inputmask";

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.initSelect2Inputs();
    $('.nab-credit-card-form [name="authenticity_token"]').remove(); //  The authenticity_token shouldn't be sent to NAB,
  }

  submitFormToNab(e) {
    preventDefaultAndStopPropagation(e);
    const form = this.formTarget;
    if(this.validateCreditCardForm(form)) {
      showRequestProcessingModal();
      form.submit();
    }
  }

  initSelect2Inputs() {
    initializeSelect2Input(
      ".select2.card-expiry-month",
      null,
      { allowClear: false, placeholder: "MM" }
    );

    initializeSelect2Input(
      ".select2.card-expiry-year",
      null,
      { allowClear: false, placeholder: "YYYY" }
    );
  }

  validateCreditCardForm(form) {
    let input = $('.card-expiry-month')[0]
    let valid = true
    let expiryYearInput = document.getElementById('EPS_EXPIRYYEAR')
    let expiryYear = parseInt(`20${expiryYearInput.value}`)
    let expiryMonth = parseInt(document.getElementById('EPS_EXPIRYMONTH').value)
    let expiryDate = new Date(expiryYear, expiryMonth, 0)
    let currentDate = new Date()

    if (expiryDate < currentDate) {
      bootbox.alert({
        message: "Please select a valid card Expiry Date. The date must be in the future.",
        closeButton: false
      });
      valid = false
    }

    return valid
  }
}
